export enum FeedsTableStatusEnum {
    NotDefined = 'not_defined',
    Active = 'active',
    Loading = 'loading',
    Error = 'error',
    NoData = 'no_data',
}
